//purpose of this file is to be the single list of actions allowed to be tracked, each naming the daily counter it feeds
//logEvent refuses any type not listed here so a typo fails immediately, a rollup can be a name, null, or a function when it depends on who acted

export const TESTER = 0;
export const DEVELOPER = 1;
export const ADMIN = 2;

//resolves the role for an event, admins return null so staff activity stays out of the figures
function roleOf(meta, fallback) {
  const raw = meta.userType !== undefined ? meta.userType : fallback;
  if (raw === null || raw === undefined || raw === "") return null;

  const userType = Number(raw);
  if (userType === DEVELOPER || userType === TESTER) return userType;
  return null;
}

//credits a daily active user to whichever role performed the action, for events both roles can trigger
function dauFor(meta, fallback) {
  const role = roleOf(meta, fallback);
  if (role === null) return null;
  return role === DEVELOPER ? "devDau" : "testerDau";
}

//returns two metrics since signing up makes someone both a new user and active that day
function newAccountFor(meta, fallback) {
  const role = roleOf(meta, fallback);
  if (role === null) return null;
  return role === DEVELOPER ? ["devNew", "devDau"] : ["testerNew", "testerDau"];
}

export const eventTypes = {
  "account.created": { rollup: newAccountFor },
  "auth.session_active": { rollup: dauFor },
  "auth.login": { rollup: dauFor },

  "project.created": { rollup: "devDau" },
  "project.updated": { rollup: "devDau" },
  "project.joined": { rollup: dauFor },

  "playtester.assigned": { rollup: "devDau" },
  "playtester.removed": { rollup: "devDau" },

  "video.uploaded": { rollup: "testerDau" },

  "session.created": { rollup: "testerDau" },
  "session.started": { rollup: "testerDau" },
  "session.completed": { rollup: "testerDau" },

  "survey.created": { rollup: "devDau" },
  "survey.submitted": { rollup: "testerDau" },
  "results.viewed": { rollup: "devDau" },
  "results.exported": { rollup: "devDau" },
  "benchmark.updated": { rollup: null },
};

export function isKnownEventType(type) {
  return Object.prototype.hasOwnProperty.call(eventTypes, type);
}



// WEBPACK FOOTER //
// ./src/util/eventTypes.js